export default __webpack_public_path__ + "static/media/video.ceea27b8.svg";